export const messages = {
  description: {
    id: 'admin/promotions.form.buy-and-win.benefit.gift.description',
  },
  detail: {
    perItem: {
      id: 'admin/promotions.form.benefit.gift.description.per-item',
    },
    perCart: {
      id: 'admin/promotions.form.benefit.gift.description.per-cart',
    },
  },
}
